/** A date for a person, such as "28 Oct 2026"; a dash when there is none. */
export function formatDate(iso: string | null, locale?: string): string {
  if (iso === null) return "—";
  return new Date(iso).toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/** A date and time for a person, such as "28 Oct 2026, 12:00"; a dash when there is none. */
export function formatDateTime(iso: string | null, locale?: string): string {
  if (iso === null) return "—";
  return new Date(iso).toLocaleString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** A UTC deadline for display, such as "28 Oct, 12:00 UTC". */
export function formatEndTime(end: Date, locale: string): string {
  const day = end.getUTCDate();
  const month = end.toLocaleString(locale, { month: "short", timeZone: "UTC" });
  const hh = String(end.getUTCHours()).padStart(2, "0");
  const mm = String(end.getUTCMinutes()).padStart(2, "0");
  return `${day} ${month}, ${hh}:${mm} UTC`;
}

/** Format the elapsed time between two ISO timestamps as a human-readable string (e.g. "2h 5m", "3m 12s", "45s"). */
export function formatDuration(startIso: string, endIso: string): string {
  const ms = new Date(endIso).getTime() - new Date(startIso).getTime();
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${sec}s`;
  return `${sec}s`;
}
